import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';

import {
  FeedbackResponse,
  FeedbackSubmit,
} from '../../../interfaces/feedback.interface';
import { API_ROUTES } from './config/api.const';
import { ConsultationRequest } from './interfaces/consultation-payload.interface';
import {
  ConsultationIdResponse,
  ConsultationListResponse,
  ConsultationResponse,
  LoadConsultationResponse,
  SecondaryRecommendationResponse,
} from './interfaces/consultation.interface';

@Injectable({
  providedIn: 'root',
})
export class ConsultationDataClient {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrlAgent = environment.apiConfig.baseUrlAgent;
  private readonly baseUrlBackend = environment.apiConfig.baseUrlBackend;

  public initializeConsultation() {
    return this.httpClient.get<ConsultationIdResponse>(
      `${this.baseUrlAgent}/${API_ROUTES.CONSULTATIONS.BASE}/${API_ROUTES.CONSULTATIONS.INITIALIZE}`,
    );
  }

  public getConsultations() {
    return this.httpClient.get<ConsultationListResponse>(
      `${this.baseUrlAgent}/${API_ROUTES.CONSULTATIONS.BASE}`,
    );
  }

  public continueConsultation(
    consultationRequest: ConsultationRequest,
    userId: number,
  ) {
    return this.httpClient.post<ConsultationResponse>(
      `${this.baseUrlAgent}/${API_ROUTES.CONSULTATIONS.BASE}/${userId}/${API_ROUTES.CONSULTATIONS.CONTINUE}`,
      consultationRequest,
    );
  }

  public getOldConsultation(consultationId: string) {
    return this.httpClient.get<LoadConsultationResponse>(
      `${this.baseUrlAgent}/${API_ROUTES.CONSULTATIONS.BASE}/${consultationId}`,
    );
  }

  public getFeedbackQuestions(organizationId: number) {
    return this.httpClient.get<FeedbackResponse>(
      `${this.baseUrlBackend}/${API_ROUTES.FEEDBACK}/${API_ROUTES.QUESTIONS}?organizationId=${organizationId}`,
    );
  }

  public submitFeedback(data: FeedbackSubmit) {
    return this.httpClient.post<void>(
      `${this.baseUrlBackend}/${API_ROUTES.FEEDBACK}`,
      data,
    );
  }

  public getSecondaryRecommendations(consultationId: string) {
    return this.httpClient.get<SecondaryRecommendationResponse>(
      `${this.baseUrlAgent}/${API_ROUTES.CONSULTATIONS.BASE}/${consultationId}/${API_ROUTES.CONSULTATIONS.RECOMMENDATIONS_SECONDARY}`,
    );
  }
}
